/* Cuisine Inspirante — bannière de cookies Consentmo plus compacte sur mobile.
   (Nom de fichier neutre : les bloqueurs de publicité bloquent les fichiers nommés « cookie-banner ».)
   Consentmo dessine sa bannière dans un shadow DOM ouvert (<csm-cookie-consent>) que le CSS du thème n'atteint pas :
   on y ajoute une feuille de style. Position et largeur restent celles de Consentmo ; seul l'intérieur est resserré.
   Accepter et Refuser sont côte à côte, de même taille ; Préférences devient un lien.
   Les règles visent les classes cc-* de Consentmo : si elles changent, rien ne s'applique et la bannière d'origine s'affiche. */
(function () {
  var W = '.cc-window.csm-cmp-bar.cc-bottom';
  var CSS = '@media (max-width: 749px) {' +
    W + '{ --csm-cc-font-size: 13px !important; padding: 12px 14px !important; }' +
    W + ' .csm-cmp-body { gap: 8px !important; padding: 0 !important; margin: 0 !important; }' +
    W + ' .cc-message { font-size: 13px !important; line-height: 1.35 !important; margin: 0 0 8px !important; padding: 0 !important; }' +
    W + ' .cc-message .cc-link { font-size: 13px !important; padding: 0 !important; margin: 0 0 0 4px !important; display: inline !important; }' +
    W + ' .cc-compliance { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 8px !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }' +
    W + ' .cc-compliance .cc-btn { width: auto !important; min-width: 0 !important; min-height: 40px !important; height: auto !important; margin: 0 !important; padding: 8px !important; font-size: 14px !important; line-height: 1.2 !important; }' +
    W + ' .cc-compliance .cc-btn.cc-deny { order: 1 !important; }' +
    W + ' .cc-compliance .cc-btn.cc-allow { order: 2 !important; }' +
    W + ' .cc-compliance .cc-btn.cc-settings { order: 3 !important; grid-column: 1 / -1 !important; min-height: 0 !important; padding: 2px !important; border: 0 !important; background: none !important; box-shadow: none !important; color: inherit !important; text-decoration: underline !important; font-size: 13px !important; }' +
  '}';
  var sheet = null;
  try { sheet = new CSSStyleSheet(); sheet.replaceSync(CSS); } catch (e) { sheet = null; }
  function attach(sr) {
    if (sheet && 'adoptedStyleSheets' in sr) {
      if (sr.adoptedStyleSheets.indexOf(sheet) === -1) sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([sheet]);
    } else if (!sr.querySelector('style[data-ci-cookie]')) {
      var s = document.createElement('style');
      s.setAttribute('data-ci-cookie', '');
      s.textContent = CSS;
      sr.appendChild(s);
    }
  }
  var tries = 0;
  function apply() {
    document.querySelectorAll('csm-cookie-consent, .csm-cmp-root').forEach(function (host) {
      if (host.shadowRoot) attach(host.shadowRoot);
    });
    /* Consentmo peut créer ou redessiner la bannière plus tard : on revérifie pendant 20 s. */
    if (++tries < 80) setTimeout(apply, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
